import { render, staticRenderFns } from "./email-list.vue?vue&type=template&id=8adb58a4&scoped=true"
import script from "./email-list.vue?vue&type=script&lang=js"
export * from "./email-list.vue?vue&type=script&lang=js"
import style0 from "./email-list.vue?vue&type=style&index=0&id=8adb58a4&prod&lang=css"
import style1 from "./email-list.vue?vue&type=style&index=1&id=8adb58a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adb58a4",
  null
  
)

export default component.exports